export default __webpack_public_path__ + "static/media/4.c5f619e5.png";